// On web, react-native-web's InteractionManager waits for every running
// JS-driven Animated animation to finish — and there is no native driver, so
// the app's endless loops (tab-bar glow, pulses) hold it open forever and the
// task never runs (Top Picks stayed on its skeleton). Run on the next idle
// period instead, with a short cap.
export function runAfterInteractions(task: () => void): { cancel: () => void } {
  const idle = (globalThis as { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number }).requestIdleCallback;
  const cancelIdle = (globalThis as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback;
  if (idle && cancelIdle) {
    const id = idle(task, { timeout: 300 });
    return { cancel: () => cancelIdle(id) };
  }
  const id = setTimeout(task, 0);
  return { cancel: () => clearTimeout(id) };
}
